import { render } from "./BeatLoader.vue?vue&type=template&id=83d5ae92&scoped=true"
import script from "./BeatLoader.vue?vue&type=script&lang=js"
export * from "./BeatLoader.vue?vue&type=script&lang=js"

import "./BeatLoader.vue?vue&type=style&index=0&id=83d5ae92&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d5ae92"]])

export default __exports__